/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ConfirmAttendance$Params {

/**
 * The ID of the student's profile.
 */
  profileId?: string;

/**
 * The ID of the meet day.
 */
  meetDayId: string;
}

export function confirmAttendance(http: HttpClient, rootUrl: string, params: ConfirmAttendance$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, confirmAttendance.PATH, 'put');
  if (params) {
    rb.query('profileId', params.profileId, {});
    rb.path('meetDayId', params.meetDayId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

confirmAttendance.PATH = '/meetday/{meetDayId}/student';
